<template>
  <div id="app">
    <div
      class="mx-3 mt-15 w-100 d-flex justify-center"
      outlined
      min-height="600px"
      v-if="res_byid.length < 1"
    >
      <div class="not-found text-center d-flex flex-column  justify-center">
        <img
          src="@/assets/img/employee_not_found.png"
          class="img-not-found"
          alt="Data Not Found"
        />
        <p class="text-bold">Anda Tidak Memiliki Data Pendidikan</p>
        <p>
          Tambahkan beberapa pendidikan untuk membuat profil Anda berkembang
        </p>
        <v-btn
          width="100%"
          @click="goToAdd"
          color="#FDB526"
          class="text-center pt-0 mt-1"
          dark
        >
          <span class="text-white">Add Pendidikan</span>
        </v-btn>
        <v-btn
          width="100%"
          @click="readstatus"
          color="grey"
          class="text-center pt-0 mt-1"
          dark
        >
          <span class="text-white">Saya belum memiliki pendidikan</span>
        </v-btn>
      </div>
    </div>
    <v-card class="mx-3 mt-15 w-100" v-else-if="res_byid.length > 0">
      <v-row class="mx-0">
        <v-col cols="12" class="app-box-grey"
          ><p class="app-sub pb-0 mb-0">Pendidikan</p></v-col
        >
        <v-col cols="12" class="app-box">
          <div class="">
            <p class="app-title-small ma-0 pt-1">
              Beri tahu kami riwayat Pendidikan lengkap Anda
            </p>
            <div v-for="(item, i) in res_byid" :key="i">
              <v-row class="border-bottom">
                <v-col cols="10" class="">
                  <div class="pa-3">
                    <v-row>
                      <v-col cols="12" class="py-1">
                        <p class="text-yellow-16 mb-1 mt-1">
                          {{ item.name }} -
                          {{ item.jurusan ? item.jurusan_name : "" }}
                        </p>
                        <p class="text-bold-14 mb-1">
                          {{ item.institution }} ( {{ item.start_year }} -
                          {{ item.end_year }} )
                        </p>
                      </v-col>
                      <v-col cols="12" class="py-1">
                        <p class="py-1 text-regular my-0">
                          GPA:
                          <span class="text-grey-14"> {{ item.gpa }}</span>
                          Nomor Sertifikat:
                          <span class="text-grey-14">
                            {{ item.certificate_no }}</span
                          >
                          Tanggal Sertifikat:
                          <span class="text-grey-14">
                            {{ item.certificate_date_con }}</span
                          >
                        </p>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
                <v-col cols="auto" class="text-right justify-end pa-1">
                  <v-btn text @click="goToEdit(item.id)" color="primary"
                    >Edit</v-btn
                  >
                  <v-icon
                    @click.prevent="showModalDelete(item.id)"
                    medium
                    color="red"
                    class="cursor-pointer"
                    >mdi-delete</v-icon
                  ></v-col
                >
              </v-row>
            </div>
            <v-alert dense type="info" class="my-3">
              Urutkan masukan dari sebelumnya ke terbaru
            </v-alert>
            <v-btn
              width="100%"
              @click="goToAdd"
              color="#FAFAFA"
              class="text-center pt-0 mt-5"
              dark
            >
              <span class="text-blue-sm">Add Pendidikan</span>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <!-- dialog success -->
    <v-dialog v-model="dialog" persistent max-width="350">
      <v-card class="pa-8 pb-10 d-flex flex-column justify-center">
        <v-icon color="green" size="100px">mdi-checkbox-marked-circle</v-icon>
        <v-card-title class="title-card mx-auto text-center"
          >{{ label }} Pendidikan <br />Success</v-card-title
        >
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn
            @click.prevent="closeSuccessNavigate"
            color="green"
            :loading="loading"
            class="mt-3 w-full"
            width="100%"
            dark
          >
            <span class="text-capitalize">Okay</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- dialog failed -->
    <v-dialog v-model="dialog2" persistent max-width="350">
      <v-card class="pa-8 pb-10 d-flex flex-column justify-center">
        <v-icon color="#F32626" size="100px">mdi-alert-circle-outline</v-icon>
        <v-card-title class="title-card mx-auto text-center"
          >{{ label }} Pendidikan <br />Failed</v-card-title
        >
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn
            @click.prevent="dialog2 = false"
            color="green"
            class="mt-3 w-full"
            width="100%"
            dark
          >
            <span class="text-capitalize">Okay</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- modal Delete -->
    <v-dialog v-model="deleteDialog" persistent max-width="450">
      <v-card class="pa-2">
        <v-card-title class="text-blood pl-2 pt-1 pr-0 pb-3"
          >Delete Pendidikan
          <v-spacer></v-spacer>
          <v-icon
            class="float-right"
            color="grey"
            @click.prevent="deleteDialog = false"
            >mdi-close</v-icon
          >
        </v-card-title>
        <div class="text-center pa-3">
          <v-avatar size="142px" class="mb-4">
            <img src="@/assets/img/delete.png" />
          </v-avatar>
          <p class="text-blood">You Want To Delete This Pendidikan?</p>
        </div>
        <v-card-actions class="py-0 px-10">
          <v-spacer></v-spacer>
          <v-btn
            width="100%"
            rounded
            color="#F5F5F5"
            @click="deleteDialog = false"
            block
            dark
          >
            <span class="text-capitalize text-blue">Close</span>
          </v-btn>
        </v-card-actions>
        <v-card-actions class="py-0 px-10 mt-3 justify-center text-center">
          <v-btn
            :loading="loadingDel"
            @click="submitDelete"
            text
            block
            color="#F32626"
            >Yes! Delete this Pendidikan</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { createNamespacedHelpers } from "vuex";
const userEdus = createNamespacedHelpers("userEdu");
export default {
  name: "userEdu",
  components: {},
  data() {
    return {
      dialog: false,
      dialog2: false,
      loading: false,
      status: null,
      moment: null,
      search: null,
      editCondition: false,
      create_new: null,
      temp_id: null,
      label: "Insert",
      deleteDialog: false,
      loadingDel: false,
      errorMessage: null
    };
  },
  watch: {},
  mounted() {
    const temp_user = JSON.parse(Cookies.get("userdata_login"));
    this.$store.commit("userEdu/SET_IDUSER", temp_user.data.id);
    this.$store.dispatch("userEdu/getById");
  },
  computed: {
    ...userEdus.mapState(["res_byid"])
  },
  methods: {
    goToAdd() {
      setTimeout(() => {
        this.$router.push("/education/add");
      }, 200);
    },
    closeSuccessNavigate() {
      setTimeout(() => {
        this.$router.push("/dashboard");
      }, 200);
    },
    showModalDelete(val) {
      this.deleteDialog = true;
      this.$store.commit("userEdu/SET_IDDATA", val);
    },
    goToEdit(val) {
      setTimeout(() => {
        this.$router.push("/education/edit/" + val);
      }, 200);
    },
    submitForm() {
      const temp_user = JSON.parse(Cookies.get("userdata_login"));
      // button effect
      if (this.editCondition === false) {
        this.create_new = 1;
        this.temp_id = null;
        this.label = "Insert";
      } else {
        this.create_new = 0;
        this.label = "Update";
      }
      this.loading = true;
      var tempProduct = {};
      tempProduct.worklocation_code = this.worklocationCode;
      tempProduct.workloation_name = this.worklocationName;
      tempProduct.create_new = this.create_new;
      tempProduct.id = this.temp_id;
      tempProduct.create_by = temp_user.data.id;

      var formData = new FormData();
      for (var key in tempProduct) {
        formData.append(key, tempProduct[key]);
      }
      this.$store.commit("userEdu/SET_TEMPINPUT", tempProduct);
      this.$store
        .dispatch("userEdu/putOrPush")
        .then(response => {
          const res = response.data;
          if (res.status) {
            this.dialog = true;
            this.loading = false;
          } else {
            this.dialog2 = true;
            this.loading = false;
          }
        })
        .catch(error => {
          const message = error.response.status.message;
          this.errorMessage = message;
          this.dialog2 = true;
          this.loading = false;
        });
    },
    readstatus() {
      const temp_user = JSON.parse(Cookies.get("userdata_login"));
      // button effect
      this.loading = true;
      var tempProduct = {};
      tempProduct.nik = temp_user.data.emp_no;
      tempProduct.institution = null;
      tempProduct.gpa = null;
      tempProduct.certificate_no = null;
      tempProduct.city = null;
      tempProduct.country = null;
      tempProduct.state = null;
      tempProduct.id_karyawan = temp_user.data.id;
      tempProduct.create_by = temp_user.data.id;

      // edit or insert
      tempProduct.create_new = 1;

      var formData = new FormData();
      for (var key in tempProduct) {
        formData.append(key, tempProduct[key]);
      }
      this.$store.commit("userEdu/SET_TEMPINPUT", formData);
      this.$store
        .dispatch("userEdu/putOrPush")
        .then(response => {
          const res = response.data;
          if (res.status) {
            this.dialog = true;
            this.loading = false;
          } else {
            this.dialog2 = true;
            this.loading = false;
          }
        })
        .catch(error => {
          const message = error.response.data.message;
          this.errorMessage = message;
          this.dialog2 = true;
          this.loading = false;
        });
    },
    submitDelete() {
      // button effect
      this.lebel = "Delete";
      this.loadingDel = true;
      this.$store
        .dispatch("userEdu/del")
        .then(response => {
          const res = response.data;
          if (res.status) {
            this.deleteDialog = false;
            this.dialog = true;
            this.loadingDel = false;
          } else {
            this.deleteDialog = false;
            this.dialog2 = true;
            this.loadingDel = false;
          }
        })
        .catch(error => {
          const message = error.response.data.message;
          this.errorMessage = message;
          this.deleteDialog = false;
          this.dialog2 = true;
          this.loadingDel = false;
        });
    }
  }
};
</script>
